import React from 'react';

import { Button } from 'design-system';

import { ExportWrap } from './styles';

type ButtonExportProps = {
  disabled: boolean;
  isLoadingExcel: boolean;
  onClick: () => void;
};

const ButtonExport: React.FC<ButtonExportProps> = ({
  disabled,
  isLoadingExcel,
  onClick,
}) => {
  return (
    <ExportWrap>
      <Button
        variant="primary"
        size="md"
        disabled={disabled}
        onClick={onClick}
      >
        {isLoadingExcel ? 'Gerando Arquivo...' : 'Exportar XLS'}
      </Button>
    </ExportWrap>
  );
};

export default ButtonExport;
